/**
 * True when a keyboard event originated from a text-editable element — a native
 * `<input>` / `<textarea>` or a `contentEditable` node. Global keyboard shortcuts
 * (Escape-to-navigate, single-letter shortcuts) should stand down for these so the
 * focused field keeps the keystroke instead of the page acting on it. [HW-727]
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el || typeof el.tagName !== 'string') return false;
  return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable === true;
}
